/*
 * Copyright (c) 2026 Bluemate B.V.
 */

export const UI_LANGUAGE_STORAGE_KEY = 'bluemate_ui_language';
export const UI_LANGUAGE_FLEX_KEY = 'ui_language';
export const DEFAULT_LANGUAGE = 'nl';
export const SUPPORTED_LANGUAGES = ['nl', 'en'] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function isSupportedLanguage(value: string | null | undefined): value is AppLanguage {
    return value === 'nl' || value === 'en';
}

export function normalizeLanguage(value: string | null | undefined): AppLanguage {
    if (!value) return DEFAULT_LANGUAGE;
    const lowerValue = value.toLowerCase();
    if (lowerValue.startsWith('en')) return 'en';
    if (lowerValue.startsWith('nl')) return 'nl';
    if (process.env.NODE_ENV === 'development')
        console.warn(`[i18n] Unknown language '${value}', falling back to '${DEFAULT_LANGUAGE}'.`);
    return DEFAULT_LANGUAGE;
}
